/**
 * plugin.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

/*global tinymce:true */

tinymce.PluginManager.add('palette', function(editor) {

	editor.addButton('palette', {
		icon: 'palette',
		tooltip: 'Edit colors',
		onclick: function() {
      window.editorStore.open();
    }
      // stateSelector: 'a[href].as-button',
		// disabledStateSelector: 'h1, h2',
    // command: 'mceButton',
	});

	// editor.addMenuItem('palette', {
	// 	icon: 'sbutton',
	// 	text: 'sButton',
	// 	onclick: alert('foo'),
	// 	prependToContext: true
	// });
});
